import { httpV2 } from "@/api/index";

const Qs = require("qs");

/**
 * Solicita o o gráfico FFT do sensor.
 * @param {Object} parameters Parametros necessários para a requisição.
 * @returns {promise} Retorna os eixos do gráfico.
 */
const GetFFTSignal = function(parameters)
{
	const params = {};
	params.signalSettingId = parameters.signalSettingId;
	params.signalRegisterId = parameters.signalRegisterId;
	params.maxFrequency = parameters.maxFrequency;

	return httpV2.get("/HydroGeneratingUnitDiagnostic/FFT", {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { encode: false }),
	});
};

/**
 * Solicita o o gráfico waveform do sensor.
 * @param {Number} resultId Id do resultado geral do modo de falha.
 * @returns {promise} Retorna os eixos do gráfico.
 */
const GetWaveformSignal = function(parameters)
{
	const params = {};
	params.signalSettingId = parameters.signalSettingId;
	params.signalRegisterId = parameters.signalRegisterId;
	params.phaseSettingId = parameters.phaseSettingId;

	return httpV2.get("/HydroGeneratingUnitDiagnostic/Waveform", {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { encode: false }),
	});
};

export default { GetFFTSignal, GetWaveformSignal };